import React from 'react';
import RsltTechListContainer from '../../containers/rslttechmng/RsltTechListContainer';

const RsltTechListPage = () => {
  return <RsltTechListContainer />;
};

export default RsltTechListPage;
